import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-metrics-grid',
  templateUrl: './metrics-grid.component.html',
  styleUrls: ['./metrics-grid.component.css']
})
export class MetricsGridComponent implements OnInit {

  title="Work Order Parameters";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/technical/work-order/metrics/metrics-grid/metrics-grid.component.ts